import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const FeaturedStrip = () => {
  return (
    <section className="bg-white border-t border-stone-200">
      <div className="max-w-screen-xl mx-auto px-6 py-16 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="aspect-[4/3] bg-stone-100 relative overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-emerald-50/50 to-stone-50 flex items-center justify-center">
              <span className="text-9xl opacity-10">🌿</span>
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="space-y-6"
          >
            <div className="space-y-3">
              <div className="text-xs font-medium text-emerald-700 tracking-wider uppercase">
                Featured Collection
              </div>
              <h2 className="text-3xl lg:text-4xl font-light text-stone-900 tracking-tight">
                Complete Wellness Range
              </h2>
            </div>
            
            <p className="text-stone-600 leading-relaxed max-w-lg">
              Experience the full spectrum of Ayurvedic wellness with our comprehensive collection. 
              Each product is crafted using traditional formulations enhanced with modern quality standards.
            </p>

            <Link to="/products">
              <button className="px-6 py-3 bg-emerald-700 text-white text-sm font-medium hover:bg-emerald-800 transition-colors duration-300">
                Explore All Products
              </button>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedStrip;
